import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookOpen,
  faComments,
  faCompress,
  faExpand,
  faArrowRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import { Navbar } from "react-bootstrap";
import Toast from "../Components/Toast";
import styles from "../Styles/MainCategoriesPage.module.css";
import gearsGif from "../Assets/gears.gif";

export const MainCategoriesPage = () => {
  const navigate = useNavigate();
  const [mainCategories, setMainCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const fetchMainCategories = async () => {
    try {
      setLoading(true);
      const token = Cookies.get("adminToken");
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/admin/main-categories`,
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );

      setMainCategories(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching main categories:", error);
      toast.error("Failed to load categories");
    } finally {
      setLoading(false);
    }
  };

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };

  const getCategoryIcon = (name) => {
    const normalized = name.toLowerCase();
    if (normalized.includes("knowledge") || normalized.includes("learn")) {
      return faBookOpen;
    }
    if (normalized.includes("community") || normalized.includes("forum")) {
      return faComments;
    }
    return faBookOpen;
  };

  const handleCategoryClick = (category) => {
    const normalized = category.name.toLowerCase();
    if (normalized.includes("community") || normalized.includes("forum")) {
      navigate(`/admin/community-forum/${category._id}`);
    } else {
      navigate(`/admin/category/${category._id}`);
    }
  };

  useEffect(() => {
    fetchMainCategories();
  }, []);

  return (
    <>
      <Toast />
      <div className={styles.pageContainer}>
        {/* Top Navbar */}
        <header className={styles.topNavbar}>
          <Navbar expand="md" bg="white" fixed="top" className={styles.navbar}>
            <div className={styles.brandContainer}>
              <h1 className={styles.brandLogo}>VroPay Admin</h1>
            </div>

            <div className={styles.navRight}>
              <button
                onClick={toggleFullScreen}
                className={styles.fullscreenBtn}
                aria-label="Toggle fullscreen"
              >
                <FontAwesomeIcon icon={isFullscreen ? faCompress : faExpand} />
              </button>
              <button
                className={styles.logoutBtn}
                onClick={() => navigate("/admin/logout")}
                aria-label="Logout"
              >
                <FontAwesomeIcon icon={faArrowRightFromBracket} />
              </button>
              <div className={styles.userAvatar}>A</div>
            </div>
          </Navbar>
        </header>

        {/* Main Content */}
        <main className={styles.mainContent}>
          <div className={styles.contentWrapper}>
            <div className={styles.header}>
              <h1 className={styles.pageTitle}>Select a Category</h1>
              <p className={styles.pageSubtitle}>
                Choose a main category to manage its content
              </p>
            </div>

            {loading ? (
              <div className={styles.loadingContainer}>
                <img src={gearsGif} alt="Loading" width="50" />
                <p>Loading categories...</p>
              </div>
            ) : mainCategories.length > 0 ? (
              <div className={styles.categoriesGrid}>
                {mainCategories.map((category) => (
                  <div
                    key={category._id}
                    className={styles.categoryCard}
                    onClick={() => handleCategoryClick(category)}
                  >
                    <div className={styles.categoryIcon}>
                      <FontAwesomeIcon icon={getCategoryIcon(category.name)} />
                    </div>
                    <h3 className={styles.categoryName}>{category.name}</h3>
                    {category.description && (
                      <p className={styles.categoryDescription}>
                        {category.description}
                      </p>
                    )}
                    <div className={styles.categoryAction}>
                      <span>Manage →</span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.emptyState}>
                <p>No categories available</p>
              </div>
            )}
          </div>
        </main>
      </div>
    </>
  );
};
